/* Founders' Mural: the room (cream wall + chess floor), the mural build, hover names, the plaque pop-up and the mouse parallax.
   Blocks come from Supabase rpc mural_public ({count, blocks: [[block, name|null], ...]}), refreshed every 60s.
   Without Supabase the page uses data-fallback (shop metafield pog.founders_count) and shows no names. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pfm]');
  if (!root || !window.PogMuralArt) return;
  var ART = window.PogMuralArt.ART, RANK = window.PogMuralArt.RANK;
  var room = root.querySelector('[data-room]'), stage = root.querySelector('[data-stage]');
  var mural = root.querySelector('[data-mural]'), tip = root.querySelector('[data-tip]');
  var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var target = Math.max(0, Math.min(2000, parseInt(root.getAttribute('data-fallback'), 10) || 0));
  var shown = still ? target : 0, names = {}, prevN = 0, sparkAt = 0, sparkIdx = -1;
  var glows = [], nextGlow = 0, INV = new Array(2000);
  for (var gi = 0; gi < 2000; gi++) INV[RANK[gi]] = gi;
  var tx = 0, ty = 0, mx = 0, my = 0, t0 = performance.now(), last = 0;
  var sgn = Math.random() < .5 ? -1 : 1, roll0 = sgn * (0.022 + Math.random() * 0.04), yaw0 = (Math.random() * 2 - 1) * 0.09;
  var BD = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
  var WT = [206, 194, 170], WB = [236, 226, 206];
  var img = null, noise = null, motes = null;

  function setCount(n) {
    target = Math.max(0, Math.min(2000, n | 0));
    var fmt = target.toLocaleString('en-US'), next = Math.min(2000, target + 1).toLocaleString('en-US');
    root.querySelectorAll('[data-count]').forEach(function (e) { e.textContent = fmt; });
    root.querySelectorAll('[data-next]').forEach(function (e) { e.textContent = next; });
    root.querySelectorAll('[data-remaining]').forEach(function (e) { e.textContent = (2000 - target).toLocaleString('en-US'); });
    var done = target >= 2000;
    root.classList.toggle('is-complete', done);
    root.querySelector('[data-join]').hidden = done;
    root.querySelector('[data-done]').hidden = !done;
  }
  setCount(target);

  function load() {
    var url = (root.getAttribute('data-sb-url') || '').replace(/\/+$/, ''), key = root.getAttribute('data-sb-key') || '';
    if (!url || !key || !window.fetch) return;
    fetch(url + '/rest/v1/rpc/mural_public', { method: 'POST', headers: { apikey: key, 'Content-Type': 'application/json' }, body: '{}' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        if (!d || !Array.isArray(d.blocks)) return;
        var nm = {};
        d.blocks.forEach(function (b) { if (b && b[1]) nm[b[0]] = String(b[1]); });
        names = nm;
        setCount(+d.count || d.blocks.length);
      })
      .catch(function () {});
  }
  load();
  setInterval(function () { if (!document.hidden) load(); }, 60000);

  /* the mural */
  var mg = mural.getContext('2d');
  function drawMural(now) {
    var S = 10, n = Math.floor(shown), lastI = -1;
    mg.fillStyle = '#05030a'; mg.fillRect(0, 0, 400, 500);
    for (var i = 0; i < 2000; i++) {
      var x = i % 40, y = (i / 40) | 0, k = RANK[i];
      if (k < n) { mg.globalAlpha = 1; mg.fillStyle = ART[i]; mg.fillRect(x * S, y * S, S, S); if (k === n - 1) lastI = i; }
      else { mg.globalAlpha = .12; mg.fillStyle = ART[i]; mg.fillRect(x * S, y * S, S, S); mg.globalAlpha = .22; mg.strokeStyle = '#0c3a5c'; mg.strokeRect(x * S + .5, y * S + .5, S - 1, S - 1); }
    }
    mg.globalAlpha = 1;
    if (n > prevN && lastI >= 0) { sparkAt = now; sparkIdx = lastI; }
    prevN = n;
    if (sparkIdx >= 0 && now - sparkAt < 700) {
      var a = (now - sparkAt) / 700, sx = (sparkIdx % 40) * S + 5, sy = ((sparkIdx / 40) | 0) * S + 5, L = 6 + a * 24;
      mg.globalAlpha = 1 - a; mg.fillStyle = '#fff8dc'; mg.fillRect(sx - L, sy - 1, 2 * L, 3); mg.fillRect(sx - 1, sy - L, 3, 2 * L); mg.globalAlpha = 1;
    }
    // Idle glow: random claimed blocks shimmer, at most 3 at a time (no permanent outline on the newest block).
    if (!still && n > 0) {
      for (var gq = glows.length - 1; gq >= 0; gq--) if (now - glows[gq].t > 1600) glows.splice(gq, 1);
      if (now >= nextGlow && glows.length < 3) {
        nextGlow = now + 600 + Math.random() * 1600;
        for (var tr = 0; tr < 8; tr++) {
          var gidx = INV[Math.floor(Math.random() * n)], dup = false;
          for (var gd = 0; gd < glows.length; gd++) if (glows[gd].i === gidx) dup = true;
          if (!dup) { glows.push({ i: gidx, t: now }); break; }
        }
      }
      for (var go = 0; go < glows.length; go++) {
        var gb = glows[go], ga = Math.sin(Math.PI * Math.min(1, (now - gb.t) / 1600)), gx = (gb.i % 40) * S, gy = ((gb.i / 40) | 0) * S, GL = 3 + ga * 7;
        mg.globalAlpha = .55 * ga; mg.fillStyle = '#fff8dc'; mg.fillRect(gx, gy, S, S);
        mg.globalAlpha = .9 * ga; mg.fillRect(gx + 5 - GL, gy + 4, 2 * GL, 2); mg.fillRect(gx + 4, gy + 5 - GL, 2, 2 * GL);
        mg.globalAlpha = 1;
      }
    }
  }

  /* the room: cream wall, crown glow, dust, and the homepage chess floor */
  function drawRoom(now) {
    var PX = Math.min(window.innerWidth, window.innerHeight) < 700 ? 8 : 6;
    var cw = Math.ceil(root.clientWidth / PX), ch = Math.ceil(root.scrollHeight / PX);
    if (room.width !== cw || room.height !== ch || !img) {
      room.width = cw; room.height = ch; img = room.getContext('2d').createImageData(cw, ch);
      noise = new Float32Array(cw * ch);
      for (var j = 0; j < cw * ch; j++) { var nv = Math.sin((j % cw) * 12.9898 + Math.floor(j / cw) * 78.233) * 43758.5453; noise[j] = nv - Math.floor(nv); }
    }
    var g = room.getContext('2d'), d = img.data;
    var rr = root.getBoundingClientRect(), fr = stage.getBoundingClientRect();
    var fx0 = (fr.left - rr.left) / PX, fx1 = (fr.right - rr.left) / PX, fy0 = (fr.top - rr.top) / PX, fy1 = (fr.bottom - rr.top) / PX;
    var bx = (fx0 + fx1) / 2, fw = fx1 - fx0, t = still ? 0 : (now - t0) / 1000;
    var roll = roll0 + mx * 0.018, yaw = yaw0 + mx * 0.08 + Math.sin(t * 0.1) * 0.02;
    var hz = fy1 + 128 / PX + my * 2, camX = mx * 0.4, camZ = t * 0.1, camH = 1.6, f = window.innerHeight / PX;
    var cr = Math.cos(roll), sr = Math.sin(roll), cy = Math.cos(yaw), sy = Math.sin(yaw), lx = mx * 0.3, lz = 3.2, lit = shown >= 1;
    var crownX = fx0 + fw * 0.49, crownY = fy0 + (fy1 - fy0) * 0.2, wallEnd = fy0 + (fy1 - fy0) * 0.3;
    for (var y = 0; y < ch; y++) {
      var weave = (y % 2 ? 4 : -4);
      for (var x = 0; x < cw; x++) {
        var i = y * cw + x, o = i * 4, n = (noise[i] - 0.5) * 14 + weave;
        var dx = x - bx, dy = y - hz, xr = dx * cr + dy * sr, v = -dx * sr + dy * cr;
        var bay = (BD[(y & 3) * 4 + (x & 3)] + 0.5) / 16 - 0.5, r, gg, b;
        if (v > 0.5) {
          var c0 = WB[0] + n * .35, c1 = WB[1] + n * .35, c2 = WB[2] + n * .4;
          var z = camH * f / v, X = xr * z / f, wx = X * cy - z * sy + camX, wz = X * sy + z * cy + camZ, sr0, sg0, sb0;
          if (((Math.floor(wx) + Math.floor(wz)) & 1) === 0) { sr0 = 234 + n; sg0 = 224 + n; sb0 = 204 + n; } else { sr0 = 20 + n * .5; sg0 = 19 + n * .5; sb0 = 26 + n * .5; }
          var k = 0.42 + 0.95 * Math.exp(-((X - lx) * (X - lx) + (z - lz) * (z - lz)) / 5.5);
          sr0 *= k; sg0 *= k; sb0 *= k;
          var dist = Math.sqrt(X * X * 1.35 + (z - 1.2) * (z - 1.2)), fog = Math.min(1, Math.max(0, (dist - 1.8) / 5.2));
          fog = Math.pow(fog * fog * (3 - 2 * fog), 0.75); fog = Math.min(0.9, Math.max(0, fog + bay * 0.14));
          r = sr0 + (92 - sr0) * fog; gg = sg0 + (72 - sg0) * fog; b = sb0 + (56 - sb0) * fog;
          var bf = Math.min(1, Math.max(0, (y - ch * 0.9) / (ch * 0.1))); bf = Math.min(1, Math.max(0, bf * bf * (3 - 2 * bf) + bay * 0.2));
          r += (c0 - r) * bf; gg += (c1 - gg) * bf; b += (c2 - b) * bf;
          if (v < 1.6) { r = 10; gg = 9; b = 13; }
        } else {
          var tt = Math.min(1, Math.max(0, y / Math.max(1, wallEnd))); tt = tt * tt * (3 - 2 * tt);
          r = WT[0] + (WB[0] - WT[0]) * tt + n * .35; gg = WT[1] + (WB[1] - WT[1]) * tt + n * .35; b = WT[2] + (WB[2] - WT[2]) * tt + n * .4;
          if (lit) {
            var Ig = Math.max(0, 1 - Math.hypot(x - crownX, (y - crownY) * 1.1) / (fw * 1.05));
            Ig = Math.max(0, Math.floor(Ig * Ig * 3 + bay + .5) / 3) * 0.4;
            r += (255 - r) * Ig; gg += (210 - gg) * Ig; b += (110 - b) * Ig;
          }
          var ao = Math.max(0, 1 + v / 7); ao = Math.floor(ao * 3 + bay + .5) / 3 * 0.22;
          r *= 1 - ao; gg *= 1 - ao; b *= 1 - ao;
        }
        d[o] = r < 0 ? 0 : r > 255 ? 255 : r; d[o + 1] = gg < 0 ? 0 : gg > 255 ? 255 : gg; d[o + 2] = b < 0 ? 0 : b > 255 ? 255 : b; d[o + 3] = 255;
      }
    }
    g.putImageData(img, 0, 0);
    if (lit) {
      if (!motes) { motes = []; for (var q = 0; q < 40; q++) motes.push({ x: Math.random() * 2 - 1, y: Math.random() * 1.7 - 1, s: 0.0008 + Math.random() * 0.0016, p: Math.random() * 6.28 }); }
      var rx = fw * 1.15, ry = fw * 0.95;
      motes.forEach(function (mo) {
        if (!still) { mo.y -= mo.s; if (mo.y < -1) { mo.y = 0.7; mo.x = Math.random() * 2 - 1; } }
        var px = crownX + (mo.x + Math.sin(t * 0.5 + mo.p) * 0.06) * rx, py = crownY + mo.y * ry;
        var a = (1 - Math.hypot((px - crownX) / rx, (py - crownY) / ry)) * (0.55 + 0.45 * Math.sin(t * 1.7 + mo.p));
        if (a > 0.08) { g.fillStyle = 'rgba(255,236,170,' + Math.min(1, a * 1.3).toFixed(2) + ')'; g.fillRect(Math.round(px), Math.round(py), 1, 1); }
      });
    }
  }

  function tick(now) {
    requestAnimationFrame(tick);
    if (now - last < 33) return;
    last = now;
    if (shown !== target) { var step = Math.max(1, Math.abs(target - shown) * 0.1); shown = shown < target ? Math.min(target, shown + step) : Math.max(target, shown - step); }
    mx += (tx - mx) * 0.08; my += (ty - my) * 0.08;
    root.style.setProperty('--mx', mx.toFixed(3)); root.style.setProperty('--my', my.toFixed(3));
    drawMural(now);
    drawRoom(now);
  }
  requestAnimationFrame(tick);

  root.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' || still) return;
    tx = e.clientX / (window.innerWidth || 1) * 2 - 1; ty = e.clientY / (window.innerHeight || 1) * 2 - 1;
  });

  /* hover a block: who placed it */
  var lastTip = -1;
  mural.addEventListener('mousemove', function (e) {
    var r = mural.getBoundingClientRect(), x = Math.floor((e.clientX - r.left) / r.width * 40), y = Math.floor((e.clientY - r.top) / r.height * 50);
    if (x < 0 || y < 0 || x > 39 || y > 49) { tip.hidden = true; return; }
    var k = RANK[y * 40 + x] + 1;
    if (k !== lastTip) {
      lastTip = k;
      tip.textContent = k <= target ? 'Block #' + k + ' · ' + (names[k] || 'Founder #' + k) : 'Block #' + k + ' · waiting for Founder #' + k;
    }
    var mr = mural.parentNode.getBoundingClientRect();
    tip.style.left = (e.clientX - mr.left + 6) + 'px'; tip.style.top = (e.clientY - mr.top + 6) + 'px';
    tip.hidden = false;
  });
  mural.addEventListener('mouseleave', function () { tip.hidden = true; lastTip = -1; });
  // Phones have no hover: a tap on the mural shows the same name tag.
  mural.addEventListener('click', function (e) { mural.dispatchEvent(new MouseEvent('mousemove', { clientX: e.clientX, clientY: e.clientY })); });
  root.addEventListener('pointerdown', function (e) { if (e.target !== mural) { tip.hidden = true; lastTip = -1; } });

  /* the plaque pop-up */
  var dlg = root.querySelector('[data-dlg]'), opener = root.querySelector('[data-plaque-open]'), closer = root.querySelector('[data-dlg-close]');
  function openDlg() { dlg.hidden = false; try { closer.focus({ preventScroll: true }); } catch (e) {} }
  function closeDlg() { if (dlg.hidden) return; dlg.hidden = true; try { opener.focus({ preventScroll: true }); } catch (e) {} }
  opener.addEventListener('click', openDlg);
  closer.addEventListener('click', closeDlg);
  dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDlg(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDlg(); });
})();

/* The red rope in front of the wall, spanning the full width of the page (2026-11-03).
   Every gold post is its own floating object: its own bob speed, timing and depth, and it shifts with the mouse
   (deeper posts move more). The rope segments are redrawn each frame between wherever the posts are, so they sag,
   stretch and sway independently. Pixel art at 5 px per art pixel (4 on phones). Posts: 27 art px shaft, heavier base (2026-11-03). Reduced motion: drawn once, still. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pfm]');
  if (!root) return;
  var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var wrap = root.querySelector('[data-rope]');
  if (!wrap) return;
  var art = wrap.querySelector('[data-rope-art]'), sh = wrap.querySelector('[data-rope-sh]');
  var TW = ['#ff5a6e', '#d81e3c', '#a8122c', '#6e0a1c'], GOLD = ['#5a3606', '#a8680c', '#e8a62a', '#ffe08a'];
  var W = 0, H = 0, P = 5, w = 0, h = 0, posts = [], g = null, sg = null, last = 0, t0 = performance.now();
  var TOP = 6, LEN = 27, HOOK = 8;
  function px(x, y, c) { g.fillStyle = c; g.fillRect(x, y, 1, 1); }
  function run(x, y, n, c) { g.fillStyle = c; g.fillRect(x, y, n, 1); }
  function rnd(i, k) { var v = Math.sin(i * 91.7 + k * 13.3) * 43758.5453; return v - Math.floor(v); }

  function layout() {
    W = wrap.clientWidth; H = wrap.clientHeight;
    if (!W || !H) return false;
    P = W < 700 ? 4 : 5; w = Math.ceil(W / P); h = Math.ceil(H / P);
    art.width = w; art.height = h; sh.width = W; sh.height = H;
    g = art.getContext('2d'); sg = sh.getContext('2d');
    // Posts every ~300px (~170px on phones), running off both edges so the rope reads as continuous.
    var gap = Math.round((W < 700 ? 170 : 300) / P), n = Math.ceil(w / gap) + 2, x0 = Math.round((w - (n - 1) * gap) / 2);
    posts = [];
    for (var i = 0; i < n; i++) posts.push({
      x: x0 + i * gap,
      depth: .55 + rnd(i, 1) * .9,                  // parallax strength
      amp: 1.4 + rnd(i, 2) * 1.6,                   // bob height, art px
      spd: (2 * Math.PI) / (4.6 + rnd(i, 3) * 2.8), // bob period 4.6-7.4s
      ph: rnd(i, 4) * 6.283,
      tilt: (rnd(i, 5) - .5) * .9,                   // sideways drift, art px
      cx: 0, cy: 0
    });
    return true;
  }

  function drawPost(cx, top) {
    run(cx - 1, top, 3, GOLD[0]);
    run(cx - 2, top + 1, 5, GOLD[2]); px(cx - 2, top + 1, GOLD[0]); px(cx + 2, top + 1, GOLD[0]); px(cx - 1, top + 1, GOLD[3]);
    run(cx - 2, top + 2, 5, GOLD[2]); px(cx - 2, top + 2, GOLD[1]); px(cx + 2, top + 2, GOLD[0]); px(cx - 1, top + 2, GOLD[3]);
    run(cx - 1, top + 3, 3, GOLD[1]);
    run(cx - 3, top + 4, 7, GOLD[0]); run(cx - 2, top + 4, 5, GOLD[2]); px(cx - 1, top + 4, GOLD[3]);
    for (var yy = top + 5; yy < top + LEN; yy++) { px(cx - 2, yy, GOLD[0]); px(cx - 1, yy, GOLD[3]); px(cx, yy, GOLD[2]); px(cx + 1, yy, GOLD[1]); px(cx + 2, yy, GOLD[0]); }
    // Same base as before, one pixel wider each side and one row deeper (2026-11-03).
    run(cx - 4, top + LEN, 9, GOLD[0]); run(cx - 3, top + LEN, 7, GOLD[1]); px(cx - 2, top + LEN, GOLD[2]);
    run(cx - 4, top + LEN + 1, 9, GOLD[0]); run(cx - 3, top + LEN + 1, 7, GOLD[1]); px(cx - 2, top + LEN + 1, GOLD[2]);
    run(cx - 2, top + LEN + 2, 5, GOLD[0]);
    var hk = top + HOOK;
    px(cx - 3, hk - 1, GOLD[2]); px(cx + 3, hk - 1, GOLD[2]); px(cx - 3, hk, GOLD[1]); px(cx + 3, hk, GOLD[1]);
  }

  function drawRopeSeg(a, b, t, s) {
    var x0 = a.cx + 3, x1 = b.cx - 3, y0 = a.cy + HOOK, y1 = b.cy + HOOK, span = x1 - x0;
    if (span < 2) return;
    // Sag breathes slightly and each segment sways on its own phase.
    var sag = Math.max(3, Math.min(h - HOOK - TOP - 6, span * .16)) + (still ? 0 : Math.sin(t * .9 + s * 1.7) * .9);
    var prev = null;
    for (var x = x0; x <= x1; x++) {
      var u = (x - x0) / span, y = Math.round(y0 + (y1 - y0) * u + sag * 4 * u * (1 - u));
      var yt = prev === null ? y : Math.min(y, prev), yb = prev === null ? y : Math.max(y, prev);
      px(x, yt - 1, '#22040a');
      for (var yy = yt; yy <= yb + 3; yy++) px(x, yy, TW[(x + yy - y + 8) & 3]);
      px(x, yb + 4, '#22040a');
      prev = y;
    }
  }

  function frame(now) {
    if (!g) return;
    var t = still ? 0 : (now - t0) / 1000;
    var mx = parseFloat(root.style.getPropertyValue('--mx')) || 0, my = parseFloat(root.style.getPropertyValue('--my')) || 0;
    posts.forEach(function (p) {
      p.cx = Math.round(p.x - mx * p.depth * 4 + Math.sin(t * p.spd * .5 + p.ph) * p.tilt);
      p.cy = Math.round(TOP + (still ? 0 : Math.sin(t * p.spd + p.ph) * p.amp) - my * p.depth * 1.6);
    });
    g.clearRect(0, 0, w, h);
    for (var s = 0; s < posts.length - 1; s++) drawRopeSeg(posts[s], posts[s + 1], t, s);
    posts.forEach(function (p) { drawPost(p.cx, p.cy); });
    // Floor shadow under each post: smaller and lighter as the post floats up.
    sg.clearRect(0, 0, W, H);
    posts.forEach(function (p) {
      var lift = (TOP - p.cy + 4) / 8, X = (p.cx + .5) * P, Y = H - 10, R = 34 * (1 - lift * .25), a = .36 * (1 - lift * .35);
      var gr = sg.createRadialGradient(X, Y, 0, X, Y, R);
      gr.addColorStop(0, 'rgba(10,9,13,' + a.toFixed(3) + ')'); gr.addColorStop(1, 'rgba(10,9,13,0)');
      sg.save(); sg.translate(X, Y); sg.scale(1, .22); sg.translate(-X, -Y); sg.fillStyle = gr; sg.fillRect(X - R, Y - R, 2 * R, 2 * R); sg.restore();
    });
  }

  function tick(now) {
    requestAnimationFrame(tick);
    if (now - last < 33) return;
    last = now;
    frame(now);
  }
  if (layout()) { frame(performance.now()); if (!still) requestAnimationFrame(tick); }
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (layout()) frame(performance.now()); }, 120); });
})();

/* The page's exit: links to Home and Fight Big Gamba drop the mural and fade to black before leaving. Going Home also
   sets pogFromChess, so the homepage plays its return (pieces rise back into place). */
(function () {
  'use strict';
  var root = document.querySelector('[data-pfm]');
  if (!root) return;
  var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.pfm-back, .pfm .pog-topnav a');
    if (!a || a.getAttribute('aria-current') || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var href = a.getAttribute('href');
    if (!href) return;
    if (href === '/') { try { sessionStorage.setItem('pogFromChess', '1'); } catch (er) {} }
    if (still) return;
    e.preventDefault();
    if (root.classList.contains('is-leaving')) return;
    root.classList.add('is-leaving');
    setTimeout(function () { window.location.href = href; }, 900);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) root.classList.remove('is-leaving'); });
})();
